import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ParentSection } from "@/components/index/ParentSection";
import { SleepConsultantSection } from "@/components/index/SleepConsultantSection";

import { useTheme } from "@/lib/theme/ThemeContext";

function Index() {
  const navigate = useNavigate();
  const { theme } = useTheme();

  return (
    <div className="min-h-screen flex flex-col transition-colors duration-300 dark:bg-background">
      <header className="p-4 flex justify-between items-center">
        <div className="text-2xl font-bold dark:text-white">Sleep Better</div>
      </header>
      
      <main className="flex-1 flex flex-col items-center justify-center p-4 md:p-8 role-selection-container">
        <div className="max-w-4xl w-full">
          <h1 className="text-3xl md:text-4xl font-bold text-center mb-8 dark:text-white role-selection-header">
            Choose Your Role
          </h1>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <SleepConsultantSection />
            <ParentSection />
          </div>
          
          <div className="mt-12 text-center">
            <p className="dark:text-muted-foreground mb-4 account-text">
              Already have an account?
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link
                to="/coach-signin"
                className="px-6 py-2 border rounded-md dark:hover:bg-slate-800 transition-colors register-link"
              >
                Sign in as Sleep Consultant
              </Link>
              <Link
                to="/signin"
                className="px-6 py-2 border rounded-md dark:hover:bg-slate-800 transition-colors register-link"
              >
                Sign in as Parent
              </Link>
            </div>
          </div>
        </div>
      </main>
      
      <footer className="text-center p-4 text-sm dark:text-muted-foreground">
        &copy; {new Date().getFullYear()} Sleep Better. All rights reserved.
      </footer>
    </div>
  );
}

export default Index;
